import React from 'react';
import { Affix } from 'antd';
import { InfoCircleOutlined, FilterOutlined } from '@ant-design/icons';

const ReportAssistant = ({ currentStep, selectedFields, filters }) => {
  const selectedDimensions = selectedFields.filter(f => f.type === 'Dimension').length;
  const selectedMeasures = selectedFields.filter(f => f.type === 'Measure').length;

  return (
    <Affix offsetTop={58}>
    <div className="assistant-card" style={{ 
      position: 'sticky', 
      top: '20px', 
      border: '1px solid #e8e8e8', 
      borderRadius: '14px', 
      padding: '0',
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)' 
    }}>
      {/* Header */}
      <div style={{ 
        fontSize: '18px', 
        fontWeight: '600', 
        color: '#262626',
        padding: '16px 16px 12px 16px',
        borderBottom: '1px solid #f5f5f5'
      }}>
        Report Assistant
      </div>
      
      <div className="assistant-content" style={{ padding: '16px' }}>
        {currentStep === 0 && (
          <div style={{
            backgroundColor: '#e6f4ff',
            borderRadius: '6px',
            padding: '12px',
            border: '1px solid #bae0ff'
          }}>
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              marginBottom: '8px'
            }}>
              <InfoCircleOutlined style={{ 
                color: '#1890ff', 
                fontSize: '14px',
                marginRight: '6px'
              }} />
              <span style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1890ff'
              }}>
                Data Source Tips
              </span>
            </div>
            <ul style={{
              margin: '0',
              paddingLeft: '16px',
              fontSize: '13px',
              color: '#595959',
              lineHeight: '1.5'
            }}>
              <li>Select one Model that contains the data you need</li>
              <li>This will be your primary data source for the report</li>
            </ul>
          </div>
        )}
        
        {currentStep === 1 && (
          <>
            <div style={{
              backgroundColor: '#f6ffed',
              borderRadius: '6px',
              padding: '12px',
              border: '1px solid #d9f7be',
              marginBottom: '12px'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#52c41a',
                margin: '0 0 4px 0'
              }}>
                Measures
              </h4>
              <p style={{
                fontSize: '13px',
                color: '#595959',
                margin: '0',
                lineHeight: '1.4'
              }}>
                Numeric data that can be calculated, summed, or averaged
              </p>
            </div>
            
            <div style={{
              backgroundColor: '#e6f4ff',
              borderRadius: '6px',
              padding: '12px',
              border: '1px solid #bae0ff',
              marginBottom: '12px'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1890ff',
                margin: '0 0 4px 0'
              }}>
                Dimensions
              </h4>
              <p style={{
                fontSize: '13px',
                color: '#595959',
                margin: '0',
                lineHeight: '1.4'
              }}>
                Categories used to group and organize your data
              </p>
            </div>
            
            <div style={{
              backgroundColor: '#fafafa',
              borderRadius: '6px',
              padding: '12px',
              border: '1px solid #e8e8e8'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#262626',
                margin: '0 0 8px 0'
              }}>
                Your Selection
              </h4>
              <ul style={{
                margin: '0',
                paddingLeft: '16px',
                fontSize: '13px',
                lineHeight: '1.5'
              }}>
                <li style={{ color: '#595959' }}>{selectedDimensions} Dimensions</li>
                <li style={{ color: '#595959' }}>{selectedMeasures} Measures</li>
                <li style={{ 
                  color: selectedDimensions > 0 || selectedMeasures > 0 ? '#52c41a' : '#bfbfbf',
                  fontWeight: selectedDimensions > 0 || selectedMeasures > 0 ? '500' : 'normal'
                }}>
                  {selectedDimensions > 0 || selectedMeasures > 0 ? 'Ready for visualization' : 'Select fields to visualize'}
                </li>
              </ul>
            </div>
          </>
        )}
        
        {currentStep === 2 && (
          <>
            <div style={{
              backgroundColor: '#e6f4ff',
              borderRadius: '6px',
              padding: '12px',
              border: '1px solid #bae0ff',
              marginBottom: '12px'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#1890ff',
                margin: '0 0 8px 0',
                display: 'flex',
                alignItems: 'center'
              }}>
                <FilterOutlined style={{ marginRight: '6px', fontSize: '14px' }} />
                Filter Logic
              </h4>
              <ul style={{
                margin: '0',
                paddingLeft: '16px',
                fontSize: '13px',
                color: '#595959',
                lineHeight: '1.5'
              }}>
                <li><strong>ALL (AND):</strong> Records must match every filter</li>
                <li><strong>ANY (OR):</strong> Records match if any filter is true</li>
              </ul>
            </div>
            
            <div style={{
              backgroundColor: '#f6ffed',
              borderRadius: '6px',
              padding: '12px',
              border: '1px solid #d9f7be'
            }}>
              <h4 style={{
                fontSize: '14px',
                fontWeight: '600',
                color: '#52c41a',
                margin: '0 0 8px 0'
              }}>
                Date Filters
              </h4>
              <ul style={{
                margin: '0',
                paddingLeft: '16px',
                fontSize: '13px',
                color: '#595959',
                lineHeight: '1.5'
              }}>
                <li>Use "this week/month/year" for dynamic ranges</li>
                <li>"Last N days" creates rolling date windows</li>
              </ul>
            </div>
          </>
        )}
        
        {currentStep === 3 && (
          <div style={{
            backgroundColor: '#fffbe6',
            borderRadius: '6px',
            padding: '12px',
            border: '1px solid #ffe58f'
          }}>
            <h4 style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#d48806',
              margin: '0 0 8px 0',
              display: 'flex',
              alignItems: 'center'
            }}>
              <InfoCircleOutlined style={{ marginRight: '6px', fontSize: '14px' }} />
              Smart Recommendations
            </h4>
            <p style={{
              fontSize: '13px',
              color: '#595959',
              margin: '0',
              lineHeight: '1.4'
            }}>
              Based on your field selection, we recommend charts that best visualize your data.
            </p>
          </div>
        )}
        
        {currentStep === 5 && (
          <>
          </>
        )}
      </div>
    </div>
    </Affix>
  );
};

export default ReportAssistant;